import { useHistory } from 'src/shared/hooks/useHistory';
import { Routes } from 'src/shared/Routes';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { useFavoritesV2Enabled } from './useFavoritesV2Enabled';

/** Hearts only render inside the meal-plan edit flow so users don't manage favorites on surfaces that can't act on them. */
export const useShouldShowFavoriteHeart = (): boolean => {
  const favoritesV2Enabled = useFavoritesV2Enabled();
  const history = useHistory();
  const isOnMealPlanEdit = !!history && locationInRoutes(history.location, [Routes.CONSUMER_MEAL_PLANS_EDIT_ORDER]);
  return favoritesV2Enabled && isOnMealPlanEdit;
};
